module.exports = __webpack_public_path__ + "media/images/user/medicalnote_logo-ad20464fae6e78b2b55ade201a7fe123.png";